export enum OrderReviewDrawers {
  Download = 'Download',
  Messages = 'Messages',
  Casepack = 'Casepack',
}

export type OrderReviewErrorFields = {
  priceType: boolean
}
